import React from "react"
import styled from "@emotion/styled"
import tw from "twin.macro"

import { withCartWidget } from "./withCartWidget"
import { CartMini } from "../Mini/CartMini"
import { Icon } from "../../Icon/Icon"
import { StyledButton } from "../../Styled/Button"

export const Button = styled(StyledButton)`
  ${({ background }) => (background == `dark` ? tw`fixed top-1 md:top-3` : tw`relative`)}
  ${tw`ml-1 md:ml-1 z-50 px-0-5`}
`
// added margin for mobile // ml-0-6
// padding new design
export const StyledIcon = styled(Icon)`
  ${tw`m-auto`}
`
const CountIcon = tw.span`absolute top-0 right-0 -m-0-6 w-2 h-2 md:-m-1-4 md:w-3 md:h-3 rounded-full bg-yellow flex items-center justify-center text-14 text-dark font-body`

export const CartWidget = withCartWidget(
  ({ count, handleActiveCart, activeCart }): JSX.Element => (
    <>
      <Button className={`icon-button`} layout={`icon`} onClick={handleActiveCart} background={activeCart ? `dark` : `light`} active={activeCart}>
        <CountIcon>{count}</CountIcon>
        <StyledIcon name={`cart`} size={24} />
        {/* <StyledIcon name={`cart`} size={15} /> */}
      </Button>
      <CartMini />
    </>
  )
)
